import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { SnoozeNotification } from '../snoozeNotification';
import { PopUp } from '../popup';
import { NotificationTab } from '../notiTime/index';
import { ServicesMenu } from '../services';
import { MenuItemId, PageContent } from '~/__modules__/page';
import { useLCS } from '~/__modules__/nds';

MainScene.propTypes = {
  availableServices: PropTypes.array,
};

export function MainScene({ availableServices }) {
  useLCS('pcset_notify');
  const { t } = useTranslation();
  const [snoozeOff, setSnoozeOff] = useState(true);
  const onSnoozeChange = (isSnoozeOff) => {
    if (isSnoozeOff !== snoozeOff) {
      setSnoozeOff(isSnoozeOff);
    }
  };

  return (
    <PageContent menuItemId={MenuItemId.NOTIFY}>
      <div className="settings_cover">
        <div className="title">
          <h3 className="title">
            <span className="text">{t('noti_main_quickset_title')}</span>
          </h3>
          <ul className="settings_list">
            <SnoozeNotification onSnoozeChange={onSnoozeChange} />
            <NotificationTab />
          </ul>
        </div>
      </div>
      {snoozeOff && (
        <div className="settings_cover">
          <h3 className="title">
            <span className="text">{t('noti_main_popupset')}</span>
          </h3>
          <ul className="settings_list">
            <PopUp availableServices={availableServices} />
          </ul>
        </div>
      )}
      <div className="settings_cover">
        <ServicesMenu services={availableServices} />
      </div>
    </PageContent>
  );
}
